import { Component, OnInit } from '@angular/core';

import { AsyncLocalStorage } from 'angular-async-local-storage';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from '../../../services/session.service';

import { FormaPago } from '../../../models/forma-pago';
import { FormaPagoService } from '../../../services/forma-pago.service';

import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';

@Component({
  selector: 'app-forma-pago-edit',
  templateUrl: './forma-pago-edit.component.html',
  styleUrls: ['./forma-pago-edit.component.css'],
  providers: [FormaPagoService,SessionService]
})

export class FormaPagoEditComponent implements OnInit {

  public title: String;
	public formaPago: FormaPago;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public loading = false;
  
  constructor(
    private FormaPagoService: FormaPagoService,
		private storage: AsyncLocalStorage,
		private ss: SessionService,
		public fb: FormBuilder,
  ) { 
    this.title = "Editar Forma Pago";
  }

  ngOnInit() {
    //Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Banco
		this.formaPago = new FormaPago();
		//Obtener datos de banco del indexedDB
		this.storage.getItem("forma-pago").subscribe(data => {
			this.formaPago = data;
			this.setValueForm();
			/*this.storage.removeItem('unidad').subscribe(() => {}, () => {});*/
		});
  }

  onSubmit() {
		this.setValueEntity();
		this.loading = true;
		this.FormaPagoService.update(this.formaPago).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
  }
  
  onForm() {
		this.myForm = this.fb.group({
			nombre: ['', [Validators.required,
			Validators.pattern(/[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]*/)]],
		});
  }
  
  setValueForm() {
		this.myForm.setValue({
			nombre: this.formaPago.nombre
		});
	}
	
	setValueEntity(){
		this.formaPago.nombre = this.myForm.controls['nombre'].value;
		this.formaPago.empresa_id = this.ss.getData('empresa_id');
		this.formaPago.usuario_id = this.ss.getData('usuario_id');
	}

	validErrorForm(campo){
		return this.vl.validErrorForm(campo,this.myForm);
	}

	validTypeMsgForm(nombre,campo){
		return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/forma-pago-edit/forma-pago-edit.component.ts